import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import OrderService from "../services/PosService/OrderService";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UtilsFormule from "../utils/UtilsFormule";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { Alert, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, TextField, DialogTitle, Button } from "@mui/material";
const DataTableTraitesShop = ({ title,tickets }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sumAmountPayed = (data) => {
    return data.reduce((total, item) => {
      return total + (item.amountPayed || 0);
    }, 0);
  };

  // Usage example:
  const totalAmount = sumAmountPayed(tickets);
  console.log(totalAmount);
  // const [tickets, setTickets] = useState(availableTicket);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [reference, setReference] = useState("");
  const [enteredReference, setEnteredReference] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { SearchBar } = Search;

  // Handle delete modal open/close
  const handleOpenDeleteModal = (row) => {
    setSelectedRow(row);
    setOpenDeleteModal(true);
    setReference(row.reference);
    console.log("setReference", row.reference)
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setSelectedRow(null);
  };
  // Handle the delete action
  const handleDelete = async () => {
    if (enteredReference === reference) {
      try {
        // Add your delete logic here
        console.log("Deleting row:", selectedRow);

        // Await the delete operation
        await OrderService.removeTicketsCaisses(getCurrentUserId(), reference);

        // Close the delete modal
        handleCloseDeleteModal();

        // Show a success toast
        toast.success("Item deleted successfully!");
      } catch (error) {
        // Handle errors
        console.error("Error deleting item:", error);
        toast.error("Failed to delete item. Please try again.");
      }
    }
  };

  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-danger"
          onClick={() => handleOpenDeleteModal(row)}
        >
          <h6>
            <small>
              <i className="fas fa-trash"></i>
            </small>
          </h6>
        </button>
      </span>
    );
  }

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  function PriceFormatter(cell, row) {
    if (cell === null || cell === "") {
      return <span>-</span>;
    } else {
      return <span>{cell} TND</span>;
    }
  }
  // function PayedFormatter(cell, row) {
  //   if (cell === 0 && row?.restToPay === row?.price) {
  //     return <span className="badge badge-danger">Non Payé</span>;
  //   } else if (cell === 0 && row?.restToPay !== row?.price) {
  //     return <span className="badge badge-warning">Payé Partiellement</span>;
  //   } else if (cell === 1) {
  //     return <span className="badge badge-success">Payé en totalité</span>;
  //   }
  // }

  function DateFormatter(cell, row) {
    if (cell != null || cell != "") {
      return UtilsFormule.formatDate(cell);
    }
  }

  const columns = [
    {
      dataField: "codeCheque",
      text: "#Référence",
      align: "center",
      headerAlign: "center",
    },

    {
      dataField: "amountPayed",
      text: "Montant",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },

    {
      dataField: "creationDate",
      text: "CD",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "echeanceDate",
      text: "Date Echeance",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "rejectDate",
      text: "Date Paiement",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "typePayementValidation",
      text: "Type",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

  ];


  function RefPayementFormatter(row) {
    if (row.typePayement === "Espéce") {
      return (
        <span>
          {row.ref}-{row.year}
        </span>
      );
    } else if (row.typePayement === "Virement") {
      return <span>{row.numVirement}</span>;
    } else if (row.typePayement === "Chéque / Traites") {
      return <span>{row.codeCheque}</span>;
    } else if (row.typePayement === "Prélevement") {
      return <span>Prélevement</span>;
    } else if (row.typePayement === "CarteCadeau") {
      return <span>Carte cadeau</span>;
    } else {
      return <span>En ligne</span>;
    }
  }
  const carteCadeauTicketInfo = (carteCadeauClient) => {
    return (
      <table
        className="table table-striped table-bordered table-sm"
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>Libellé</th>
            <th style={{ width: "15%" }}>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr>

            <td className="text-center">{carteCadeauClient.ref || ""}</td>
            <td className="text-center">{carteCadeauClient?.carteCadeau?.name || ""}</td>
            {/* <td className="text-center">{product.sku || ""}</td> */}
            <td className="text-center">{carteCadeauClient?.carteCadeau?.value || ""}</td>
          </tr>

        </tbody>
      </table>
    );
  };
  const especeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Espèce</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const enLigneInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>En ligne</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const virementInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Virement</td>
              <td>{row.numVirement}</td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const chequeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref.Cheque</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Chèque/ traites</td>
              <td>{row.codeCheque}</td>

              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const prelevementInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Prélevement</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const carteCadeauInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Carte cadeau</td>
                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Carte cadeau</td>
                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Carte cadeau</td>                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Carte cadeau</td>
              <td>
                {row.ref}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const productsTicketInfo = (products) => {
    return (
      <table
        className="table table-striped table-bordered table-sm"
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Code produit</th>
            <th style={{ width: "15%" }}>Code à barre</th>
            <th>Produit</th>
            {/* <th style={{ width: "15%" }}>SKU</th> */}
            <th style={{ width: "15%" }}>Quantité</th>
            <th style={{ width: "15%" }}>Prix de vente</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={index}>
              {/* <td>
                {product.barcode || ""} - {product.name || ""}
              </td> */}
              <td className="text-center">{product.productCode || ""}</td>
              <td className="text-center">{product.barcode || ""}</td>
              <td>{product.name || ""}</td>
              {/* <td className="text-center">{product.sku || ""}</td> */}
              <td className="text-center">{product.quantity || ""}</td>
              <td className="text-center">{product.priceAfterDiscount || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const expandRow = {
    renderer: (row) => (
      <>
        {row?.payementEchange?.pisNew &&
          row?.payementEchange?.pisNew.length > 0 ? (
          <>
            <div
              className="text-center mt-2 mb-3"
              style={{ fontStyle: "italic" }}
            >
              <b> Informations de paiement {row?.payementEchange?.ref} </b>
            </div>
            {row?.payementEchange.pisNew.map((item) => {
              switch (item?.typePayement) {
                case "Espéce":
                  return especeInfo(item);
                case "En ligne":
                  return enLigneInfo(item);
                case "Chéque / Traites":
                  return chequeInfo(item);
                case "Virement":
                  return virementInfo(item);
                case "Prélevement":
                  return prelevementInfo(item);
                case "CarteCadeau":
                  return carteCadeauInfo(item);
                default:
                  return null;
              }
            })}
          </>
        ) : (
          <div
            className="text-center mt-2 mb-3"
            style={{ fontStyle: "italic" }}
          >
            <b> Informations de paiement </b> : Pas de payement !
          </div>
        )}

      </>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ tickets }) {
    return tickets;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const handleExportExcel = ({ dataToExport }) => {
    const headers = [
      { key: "Reference", text: "Référence" },
      { key: "priceBeforePromotion", text: "Prix Avant Promotion" },
      { key: "Prix", text: "Prix" },
      { key: "isPayed", text: "Est Payé" },
    ];

    // Check if tickets exist and have data
    if (!tickets || tickets.length === 0) {
      toast.error("No data to export.");
      return;
    }

    // Use all tickets if dataToExport is undefined or empty
    const dataToExportFinal =
      dataToExport && dataToExport?.length > 0 ? dataToExport : tickets;

    // Format data for export
    const data = dataToExportFinal.map((item) => ({
      Reference: item.reference,
      priceBeforePromotion: item.priceBeforePromotion,
      Prix: item.price,
      isPayed:
        item.isPayed === 1
          ? "Payé en totalité"
          : item.isPayed === 0 && item?.restToPay === item?.price
            ? "Payé Partiellement"
            : "Non Payé",
    }));

    // Create the worksheet with custom headers
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Manually insert headers with custom texts
    XLSX.utils.sheet_add_aoa(worksheet, [headers.map((h) => h.text)], {
      origin: "A1",
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "tickets Data");

    const filename_ticket = `tickets_${UtilsFormule.formatDateHours(
      new Date()
    )}.xlsx`;
    XLSX.writeFile(workbook, filename_ticket);
  };

  return (
    <>   {totalAmount !== null && (
      <div className="col-sm-6 col-12">
        <div className="info-box bg-gray-dark">
          <span className="info-box-icon">
            <i class="fas fa-sack-dollar"></i>
          </span>
          <div className="info-box-content">
            <span className="info-box-text">Total </span>
            <span className="info-box-number">{totalAmount}</span>
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "100%" }}
              />
            </div>
            <span className="progress-description"></span>
          </div>
        </div>
      </div>
    )}
      <div className="card">

        <div className="card-header">
          <h3 className="card-title">Paiements par {title}</h3>


        </div>
        <div className="card-body">
          <ToolkitProvider
            keyField="id"
            data={tickets}
            columns={columns}
            onTableChange={handleTableChange}
            exportCSV
            search
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    />
                  </div>
                  <div className="ml-auto mr-0">
                    <MyExportCSV {...props.csvProps} />{" "}
                  </div>
                </div>
                <div className="row">
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    striped
                    hover
                    condensed
                    expandRow={expandRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </div>

        {openInfoAlert && (
          <Snackbar
            open={openInfoAlert}
            autoHideDuration={2000}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Alert variant="filled" onClose={handleInfoClose} severity="info">
              {infoAlertText}
            </Alert>
          </Snackbar>
        )}

        <Dialog
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">Confirmer la Suppression</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              Veuillez écrire la référence <strong>{reference}</strong> ci-dessous pour confirmer la suppression. Cette action est irréversible.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="reference-input"
              label="Entrez la Référence"
              type="text"
              fullWidth
              value={enteredReference}
              onChange={(e) => setEnteredReference(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteModal} color="secondary">
              Annuler
            </Button>
            <Button
              onClick={handleDelete}
              color="primary"
              disabled={enteredReference !== reference}
            >
              Confirmer & Supprimer
            </Button>
          </DialogActions>
        </Dialog>


      </div>
    </>
  );
};
export default DataTableTraitesShop;
